<template>
  <div>
    <figure v-if="item.type === 'image'" :class="{ 'mb-2 md:pb-8': !hasBlockCaption }" class="mt-2 lg:mt-4">
      <base-image :img="item" @click.native="focus(item.src)" class="w-full" />
      <figcaption v-if="item.content && !hasBlockCaption" v-html="item.content.caption" class="text-xs mt-2 text-left"></figcaption>
    </figure>

    <div v-else-if="item.type === 'video'" :class="{ 'md:pb-8': !hasBlockCaption }" class="my-2 lg:my-4">
      <div>
        <video :src="item.src" controls></video>
      </div>
      <div v-if="item.content && !hasBlockCaption" v-html="item.content.caption" class="text-xs mt-2 text-left"></div>
    </div>

    <div v-else-if="item.type === 'audio'" :class="{ 'md:pb-8': !hasBlockCaption }" class="my-2 lg:my-4">
      <div class="w-full">
        <div class="p-4 rounded bg-gray-600 w-screen max-w-full">
          <audio :src="item.src" controls class="w-full"></audio>
        </div>
        <div v-if="item.content && !hasBlockCaption" v-html="item.content.caption" class="text-xs mt-2 text-left"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mdImg, lgImg } from '@/utils'

export default {
  name: 'MediaItem',
  props: {
    item: Object,
    block: [String, Boolean, undefined]
  },
  data () {
    return {
      blank: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    }
  },
  computed: {
    hasBlockCaption () {
      return typeof this.block === 'string'
    }
  },
  methods: {
    mdImg,
    lgImg,

    focus (src) {
      this.$emit('img-select', src)
    }
  }
}
</script>
